import * as React from 'react';
import * as _ from 'underscore';

import { MetricCardWithTimeSeries } from '@tableau/metrics-shared-widgets-dom/lib/src/MetricCardWithTimeSeries';
import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { metricCardProps } from '../../../metrics/metricCardPropsFromDataPoints';
import { L10n } from '../../../ts/L10n/L10n';
import { IMetricDataInfo, isMetricInfo } from '../../../ts/models/IMetricInfo';
import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { MetricTooltip } from '../Tooltips/MetricTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, ContentCardProps, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';
interface MetricCardState {
  readonly metricData?: IMetricDataInfo;
}

export interface MetricCardOwnProps extends ContentCardProps {
}

export interface MetricCardStateProps {
  readonly metricData: IMetricDataInfo;
}

export type MetricCardProps = MetricCardOwnProps & MetricCardStateProps;

export class MetricCard extends ContentCard<MetricCardProps, MetricCardState> {
  public state: MetricCardState = {};

  private renderTimerHandle?: ReturnType<typeof setTimeout>;

  public render() {
    const containerClasses = this.props.hoveredOrSelected && this.haveMetricDataPoints() ? [CardViewStyles.ThumbnailPreloaded, CardViewStyles.CardHighlight]
      : [CardViewStyles.ThumbnailPreloaded];
    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor tooltipContent={this.renderTooltipContent} width={DetailsTooltipStyles.Width} onShowTooltip={this.handleShowTooltip}
          title={Messages.metricDetails()} disableAutoFocus={this.props.content.owner && this.props.content.owner.isHiddenInternalUser}>
          <div className={containerClasses.join(' ')} >
            <div className={CardViewStyles.SelectOverlay}></div>
              <a href={getContentUrlForItem(this.props.content, this.props.urls)} style={{ textDecoration: 'none' }}>
                {this.renderMetricCard()}
              </a>
          </div>
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            {L10n.elideIfLong(this.props.content.name)}
          </span>
          <span>
            <FavoriteToggle canHaveKeyboardFocus={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite(this.props.content.id, 'metric')}
              onRemoveFavorite={() => this.props.removeContentFavorite(this.props.content.id, this.props.content.id, 'metric', this.props.content.name)} />
          </span>
          { this.renderActionsMenu() }
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return <MetricTooltip content={this.props.content}
                          urls={this.props.urls}
                          lastUpdatedTimestamp={this.state.metricData ? metricCardProps(this.state.metricData).lastUpdatedTimestamp : undefined}
                          inProjectSpace={this.props.inProjectSpace}/>;
  }

  public componentDidUpdate(): void {
    this.delayAddingDataToState(this.state, this.props.content);
  }

  public componentDidMount(): void {
    this.delayAddingDataToState(this.state, this.props.content);
  }

  public componentWillUnmount() {
    if (this.renderTimerHandle) {
      clearTimeout(this.renderTimerHandle);
    }
  }

  private delayAddingDataToState(state: MetricCardState, content: IExplorableItemTypeInfo): void {
    if (isMetricInfo(content) && this.props.metricData !== state.metricData) {
    this.renderTimerHandle = setTimeout(() => this.setState({metricData: this.props.metricData}),
      Math.floor(Math.random() * 10));
    }
  }

  private renderMetricCard() {
    if (this.haveMetricDataPoints()) {
      return (
        <MetricCardWithTimeSeries {...metricCardProps(this.state.metricData)} />
      );
    } else {
      return (
        <Thumbnail
          defaultImageUrl={imgPath('Spaces_Empty_Metrics.svg')}
          hoveredOrSelected={this.props.hoveredOrSelected}
          navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
          useBase64EncodedImage={true}
          dontShowBorder={true} // we already add a border around this metrics card so we don't want the thumbnail do add another border
        />
      );
    }
  }

  private haveMetricDataPoints(): boolean {
    return isMetricInfo(this.props.content) && this.state.metricData && !_.isUndefined(this.state.metricData.dataPoints);
  }
}
